export default __webpack_public_path__ + "static/media/apple_btn.92e90888.svg";